/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:1823a607-7a06-4de4-847d-7a86d83f46eb",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_oX2zNw7cX",
    "aws_user_pools_web_client_id": "23eb7gr42ttbvdok691jfrdvgg",
    "oauth": {
        "domain": "feature-board-prod.auth.eu-central-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.feedback-board.com/,https://www.feedback-board.com/,https://www.feature-board.eu/,http://localhost:3000/",
        "redirectSignOut": "https://app.feedback-board.com/,https://www.feedback-board.com/,https://www.feature-board.eu/,http://localhost:3000/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_login_mechanisms": [
        "EMAIL"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://mavbgxpwk5fzhpldpcmnf2srtm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-a6v6kpiy3jeu5m5feklu7345cy"
};


export default awsmobile;
